import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { translationChunksConfig } from '@spartacus/assets';
import { I18nModule, provideConfig } from '@spartacus/core';
import { SearchBoxModule } from '../../../search-box/search-box.module';
import { CustomPipesModule } from '../../pipes/custom-pipes.module';
import { QuickOrderComponent } from './quick-order/quick-order.component';
import { AutoSizeInputModule } from 'ngx-autosize-input';
import { ContractComponent } from '../contract/contract.component';
import { ContractPriceGroupComponent } from '../contract-price-group/contract-price-group.component';
import { ContractsPartialComponent } from '../contracts-partial/contracts-partial.component';

@NgModule({
  declarations: [QuickOrderComponent],
    imports: [
        CommonModule,
        SearchBoxModule,
        NgbModule,
        I18nModule,
        CustomPipesModule,
        AutoSizeInputModule,
        ContractComponent,
        ContractPriceGroupComponent,
        ContractsPartialComponent,
    ],
  exports: [QuickOrderComponent],
  providers: [
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
  ],
})
export class QuickOrderModule {}
